/**
 * Wittenwald Size Chart Manager storefront integration.
 * Works across theme section morphs; does not intercept variant changes.
 * Never makes network requests and never modifies product/cart state.
 */
(() => {
  if (window.__wwSizeChartV1Ready) return;
  window.__wwSizeChartV1Ready = true;

  let openDialog = null;
  let returnFocus = null;

  function close(dialog) {
    if (dialog && dialog.open) dialog.close();
  }

  function setUnit(dialog, unit) {
    if (unit !== 'cm' && unit !== 'in') return;
    dialog.querySelectorAll('[data-ww-size-chart-table]').forEach((table) => {
      table.hidden = table.dataset.wwSizeChartTable !== unit;
    });
    dialog.querySelectorAll('[data-ww-size-chart-unit]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.wwSizeChartUnit === unit));
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-ww-size-chart-open], [data-ww-size-chart-close], [data-ww-size-chart-unit]') : null;
    if (!button) return;

    if (button.hasAttribute('data-ww-size-chart-open')) {
      const dialogId = button.getAttribute('data-ww-size-chart-open');
      const dialog = document.getElementById(dialogId || '');
      if (!(dialog instanceof HTMLDialogElement) || !dialog.hasAttribute('data-ww-size-chart-dialog')) return;
      event.preventDefault();
      if (dialog.open) return;
      // Native showModal handles focus trapping and Esc/cancel.
      returnFocus = button;
      setUnit(dialog, 'cm');
      dialog.showModal();
      openDialog = dialog;
      document.documentElement.classList.add('ww-size-chart-active');
      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('ww-size-chart-active');
        openDialog = null;
        if (returnFocus && returnFocus.isConnected) returnFocus.focus({ preventScroll: true });
        returnFocus = null;
      }, { once: true });
      return;
    }

    const dialog = button.closest('dialog[data-ww-size-chart-dialog]');
    if (!(dialog instanceof HTMLDialogElement)) return;
    if (button.hasAttribute('data-ww-size-chart-close')) {
      event.preventDefault();
      close(dialog);
    } else if (button.hasAttribute('data-ww-size-chart-unit')) {
      event.preventDefault();
      setUnit(dialog, button.getAttribute('data-ww-size-chart-unit'));
    }
  });

  // Clicking the backdrop closes the popup without changing the selected variant.
  document.addEventListener('click', (event) => {
    if (event.target !== openDialog || !openDialog) return;
    const rect = openDialog.getBoundingClientRect();
    const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    if (outside) close(openDialog);
  });
})();
